<template>
     <div class="version2-left-top">
        <Header title="本年新增专利统计"></Header>
        <div class="version2-left-top-block">
            <div v-for="(item,index) in patentList" :key="item.name" class="row" :class="'row'+index" @click="detailClick(item)">
                <div class="label">{{ item.label }}</div>
                <div class="count">{{ parseToThousandth(item.count) }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../../commonHeader/two.vue'
import {parseToThousandth} from '@/utils'
import { patentIncrease } from '@/api/databaseBin'
import BaseMixin from '@/views/_mixin'
import moment from 'moment'
export default {
  mixins: [BaseMixin],
  data() {
    return {
      patentList: [
        { label: '新增专利申请', name: 'apply', count: 1110, exp: '专利类型=(发明申请 or 实用新型 or 外观设计) and (申请年 = 开始时间)'},
        { label: '新增专利授权', name: 'authorization', count: 1120, exp: '专利类型=(发明授权 or 实用新型 or 外观设计) and (申请年 = 开始时间)'},
        { label: '新增发明专利', name: 'inventApply', count: 0, exp: '专利类型=(发明申请 or 发明授权) and (申请年 = 开始时间)'},
        { label: '新增发明授权', name: 'effect', count: 0, exp: '专利类型=发明授权 and 专利状态=有效 and (申请年 = 开始时间)'}
      ],
      parseToThousandth
    }
  },
  components: {
    Header
  },
  mounted() {
    this.getPatent()
  },
  methods: {
    detailClick(item) {
      // const startDate = moment().startOf('day').format('YYYY-MM-DD')
      // const endDate = moment().startOf('year').format('YYYY-MM-DD')
      const year = moment().format('YYYY')
      let exp = ''
      exp = item.exp.replace('开始时间', year)
      this.jumpIpi(exp, 'isMerge')
    },
    getPatent() {
      patentIncrease().then(res => {
        if (res[this.codeMapping]) {
          this.patentList.forEach(item => {
            res[this.dataMapping].forEach(ele => {
              if (item.name === ele.name) {
                item.count = ele.count
              }
            })
          })
        }
      })
    }
  }
}
</script>
